import {
  GetPolicyWithAgencyDataQueryResult,
  GetPolicyWithCheckReceivalDataQueryResult,
  useGetPolicyWithAgencyDataQuery,
  useGetPolicyWithCheckReceivalDataQuery,
} from "@covertree/agent-portal-graphql";

/**
 * Getting policy details base on policyLocator and user's permissions. Executes the proper query and maps the query's result.
 *
 * @returns - query result
 */
export function useGetPolicy(
  policyLocator: string,
  canMarkRenewalAsPaid: boolean
):
  | GetPolicyWithAgencyDataQueryResult
  | GetPolicyWithCheckReceivalDataQueryResult {
  if (canMarkRenewalAsPaid) {
    return useGetPolicyWithCheckReceivalDataQuery({
      variables: { policyLocator },
      fetchPolicy: "cache-and-network",
    });
  }

  return useGetPolicyWithAgencyDataQuery({
    variables: { policyLocator },
    fetchPolicy: "cache-and-network",
  });
}
